import process from 'process';

// Force global assignment
if (typeof window !== 'undefined') {
    window.process = process;
    // Some libs check global.process
    window.global = window;
    window.global.process = process;
}

// Ensure critical properties exist
window.process.env = window.process.env || {};
window.process.env.NODE_ENV = window.process.env.NODE_ENV || 'development';
window.process.version = '';
window.process.versions = { node: '0.0.0' };
window.process.platform = window.process.platform || 'browser';
window.process.browser = true; // Explicitly set for libs checking this
window.process.stdout = window.process.stdout || { write: () => { } };
window.process.stderr = window.process.stderr || { write: () => { } };

// Shim nextTick if missing
if (!window.process.nextTick) {
    window.process.nextTick = (cb) => setTimeout(cb, 0);
}
